import { render, staticRenderFns } from "./ModelUserRecord.vue?vue&type=template&id=569f5e90&scoped=true&"
import script from "./ModelUserRecord.vue?vue&type=script&lang=js&"
export * from "./ModelUserRecord.vue?vue&type=script&lang=js&"
import style0 from "./ModelUserRecord.vue?vue&type=style&index=0&id=569f5e90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569f5e90",
  null
  
)

export default component.exports